<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card flat tile>
        <v-toolbar dense flat color="white">
          <v-toolbar-title class="font-weight-bold">
            <v-icon class="mr-2">edit</v-icon>방문증 분실신고 항목 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="ml-4 mr-4"></v-divider>

        <!-- <v-card outlined tile class="ma-4">
          <v-card-text class="mt-2 mb-2 pb-0">
          </v-card-text>
        </v-card>
        <v-card outlined tile class="ma-4 mb-0 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
          </v-card-text>
        </v-card> -->
        <v-card outlined tile class="ma-4">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cLostCustomNm" @keyup="ResetLostInfo()" @keyup.enter="ShowLostCustomDialog()" @click:append-outer="ShowLostCustomDialog()" append-outer-icon="search" class="essetial_input" dense persistent-placeholder>
                  <template v-slot:label>
                    분실자명<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="editedItem.cLocal == 'Y'" v-model="editedItem.cCorpNmKor" label="업체명" dense disabled persistent-placeholder></v-text-field>
                <v-text-field v-else v-model="editedItem.cCorpNmEng" label="업체명" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.cTel"
                  label="전화번호"
                  dense
                  disabled
                  persistent-placeholder
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined tile class="ma-4 essetial_card">
          <v-card-text class="mt-2 mb-2 pb-0">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <!-- <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" cLabel="분실일자" :bSelect="bSelect" :sMaxDate="sToday"/> -->
                <IronDate ref="IronDateRef" v-model="editedItem.cLostDateTime" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" cLabel="분실일자" :bSelect="bSelect" :sMaxDate="sToday" style="width:100%"/>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.cPassNm" label="방문증 번호" dense disabled persistent-placeholder></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="zSelecetedLostItem" :items="zLostItemInfo" :menu-props="{ bottom: true, offsetY: true,closeOnContentClick : bCheckMenuList }" multiple dense persistent-placeholder>
                  <template v-slot:label>
                    분실물품<strong class="red--text">*</strong>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-chip small>
                      <span>{{ item.text }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggle" :class="zSelecetedLostItem.length > 0 ? 'grey lighten-1' : ''">
                      <v-list-item-action>
                        <v-icon :color="zSelecetedLostItem.length > 0 ? 'black' : ''">
                          {{ cCheckBoxIcon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          전체 선택
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item ripple @mousedown.prevent @click="fPushItem(item)" :class="zSelecetedLostItem.includes(item) ? 'grey lighten-1' : ''">
                      <v-list-item-action>
                        <v-icon :class="zSelecetedLostItem.includes(item) ? 'mdi mdi-checkbox-marked' : 'mdi mdi-checkbox-blank-outline'" :color="zSelecetedLostItem.includes(item) ? 'black' : ''"></v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <div align="right">
                      <v-btn @click="bCheckMenuList = true" class="mr-2" dark small><v-icon>mdi-check</v-icon>선택</v-btn>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <div align="right" class="pa-4">
          <v-divider class="mb-2"></v-divider>
          <v-btn @click="dialog = false;" text class="mr-2"><v-icon class="mr-1">mdi-close</v-icon>취소</v-btn>
          <v-btn @click="SetPassLog()" dark class="ml-2"><v-icon class="mr-1">save</v-icon>저장</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <ChargeDialog ref="ChargeDialogRef" @SetLostCustom="SetLostCustom"/>
  </div>
</template>

<script>
import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate4.vue';
import Util from "../Util.js";

import ChargeDialog from "./ChargeDialog.vue";

export default {
  components: {
    IronDate,
    ChargeDialog,
  },
  data: () => ({
    bCheckMenuList : false,
    iEditIndex : -1,
    dialog : false,
    bSelect : true,
    sToday : new Date(),
    editedItem : {
      cIdx : "",
      cState : "",
      cLostCustomId : "",
      cLostCustomNm : "",
      cLostDateTime : Util.sFormatDate(Date()),
      cPassId : "",
      cPassNm : "",
      cTel : "",
      cLocal : "",
      cCorpNmEng : "",
      cCorpNmKor : "",
      cPassMappingId : "",
    },
    zSelecetedLostItem: [],
  }),
  computed: {
    ...mapState(["CustomInfo","zLostItemInfo"]),
    likesAllFruit () {
      return this.zSelecetedLostItem.length === this.zLostItemInfo.length
    },
    likesSomeFruit () {
      return this.zSelecetedLostItem.length > 0 && !this.likesAllFruit
    },
    cCheckBoxIcon () {
      if (this.likesAllFruit) return 'mdi-checkbox-marked'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    cCheckSelectIcon () {
      if (this.likesAllFruit) return 'mdi-checkbox-marked'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  created() {
  },

  mounted() {
  },

  methods : {
    // 창 열었을때 해당 열의 내용 가져오기
    ShowDialog(item,index,LostpassItem){
      this.dialog = true;
      this.iEditIndex = index;

      // this.editedItem = JSON.parse(JSON.stringify(item));

      this.editedItem.cIdx = item.cIdx
      this.editedItem.cState = item.cState
      this.editedItem.cLostCustomId = item.cLostCustomId
      this.editedItem.cLostCustomNm = item.cLostCustomNm
      this.editedItem.cLostDateTime = item.cLostDateTime
      this.editedItem.cPassId = item.cPassId
      this.editedItem.cPassNm = item.cPassNm
      this.editedItem.cTel = item.cTel
      this.editedItem.cLocal = item.cLocal
      this.editedItem.cCorpNmEng = item.cCorpNmEng
      this.editedItem.cCorpNmKor = item.cCorpNmKor
      this.editedItem.cPassMappingId = item.cPassMappingId

      this.zSelecetedLostItem = []
      for (let i = 0; i < LostpassItem.length; i ++) {
        let oTest = this.zLostItemInfo.filter((item) => {
          return item.value == LostpassItem[i].cItemValue;
        });
        this.zSelecetedLostItem.push(oTest[0])
      }
    },

    fPushItem(item) {
      this.bCheckMenuList = false
      let iIndex = this.zSelecetedLostItem.indexOf(item)
      if (iIndex == -1) {
        this.zSelecetedLostItem.push(item)  
      } else {
        this.zSelecetedLostItem.splice(iIndex,1)
      }
      this.zSelecetedLostItem.sort(function(a, b){
        return a.value - b.value
      })
    },

    toggle() {
      this.$nextTick(() => {
        this.bCheckMenuList = false
        if (this.likesAllFruit) {
          this.zSelecetedLostItem = []
        } else {
          this.bCheckMenuList = true
          this.zSelecetedLostItem = this.zLostItemInfo.slice()
        }
      })
    },

    ResetLostInfo(){
      this.editedItem.cPassNm = ""
      this.editedItem.cTel = ""
      this.editedItem.cPassId = ""
      this.editedItem.cPassMappingId = ""
      this.editedItem.cLostCustomId = ""
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.cLostDateTime = Util.sFormatDate(daterange.startDate);
    },

    // 분실자 선택 창 열기
    ShowLostCustomDialog(){
      this.$refs.ChargeDialogRef.ShowDialog(3,this.editedItem.cLostCustomNm);
    },

    // 분실자 정보 가져오기
    SetLostCustom(item){
      this.editedItem.cLocal = item[0].cLocal
      this.editedItem.cCorpNmEng = item[0].cCorpNmEng
      this.editedItem.cCorpNmKor = item[0].cCorpNmKor
      this.editedItem.cLostCustomId = item[0].cCustomId
      this.editedItem.cLostCustomNm = item[0].cCustomNm
      this.editedItem.cPassId = item[0].cPassId
      this.editedItem.cPassNm = item[0].cPassNm
      this.editedItem.cTel = item[0].cTel
      this.editedItem.cPassMappingId = item[0].cPassMappingId
    },

    // 분실신고 신청 수정
    SetPassLog(){
      if (this.editedItem.cLostCustomId == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","분실자를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cPassId == "") {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","방문증 번호를 입력하여 주세요.");
        return
      }

      if (this.zSelecetedLostItem.length == 0) {
        EventBus.$emit("onShowMsgBox", "필수 입력 사항이 누락되었습니다.","분실한 물품을 선택하여 주세요.");
        return
      }

      var posData = {
        PassMappingId : this.editedItem.cPassMappingId,
        Idx : this.editedItem.cIdx,
        CustomId : this.CustomInfo.CustomId,
        CorpId : this.CustomInfo.CorpId,
        PassId : this.editedItem.cPassId,
        PassNm : this.editedItem.cPassNm,
        LostCustomId : this.editedItem.cLostCustomId,
        // LostCustomNm : this.editedItem.cLostCustomNm,
        LostDateTime : this.editedItem.cLostDateTime,
        Tel : this.editedItem.cTel,
        // LostCorpNmKor : this.editedItem.cCorpNmKor,
        Manager : this.CustomInfo.Manager,
        LostItem : this.zSelecetedLostItem
      };

      axios
        .post(BasicInfo.UIL_API + "SetPassLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.zSelecetedLostItem = []
            this.$emit("SetLostPassLog",this.editedItem,this.iEditIndex)
            EventBus.$emit("onShowMsg",false,  "수정이 완료되었습니다.");
            this.dialog = false;
          } else if (res.data.ResultCd === "02") {
            EventBus.$emit("onShowMsgBox","관리자 권한이 변경 되었습니다.",  "화면을 다시 접속하여 주세요.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else if (res.data.ResultCd === "06") {
            // let sTitle = ""

            // if (this.CustomInfo.Manager == "M") sTitle = "협력업체 관리자가 검토를 마친 사항입니다."
            // else sTitle = "담당자가 접수한 사항 입니다."

            // EventBus.$emit("onShowMsgBox",sTitle, "초기화 버튼을 눌러서 상태 항목을 확인하여 주세요.");
            EventBus.$emit("onShowMsgBox","담당자가 접수한 사항 입니다.", "초기화 버튼을 눌러서 상태 항목을 확인하여 주세요.");
          } else if (res.data.ResultCd === "08") {
            EventBus.$emit("onShowMsgBox","협력업체 관리자가 검토를 마친 사항입니다.", "초기화 버튼을 눌러서 상태 항목을 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>